// extracted by mini-css-extract-plugin
export var addToCartButton = "_p6-b";
export var arrowButtonContainer = "_p6-9";
export var arrowButtonIcon = "_p6-a";
export var carouselArrowButton = "_p6-6";
export var carouselElementContainer = "_p6-1";
export var galleryThumbnail = "_p6-d";
export var galleryThumbnailImage = "_p6-e";
export var left = "_p6-7";
export var productDisplayCarouselContainer = "_p6-0";
export var productTileContainer = "_p6-2";
export var productTileImage = "_p6-4";
export var productTileImageContainer = "_p6-3";
export var productTileTitle = "_p6-5";
export var right = "_p6-8";
export var sliderOverflow = "_p6-c";